import { DataboxProviders } from '@common/Databox/DataboxProviders';

import { HomeChatPage } from './HomeChatPage';

/** Attachments upload through the Databox dataplane, which needs the workspace fabric and its JWT. */
export function HomeChatRoute() {
  return (
    <DataboxProviders>
      <HomeChatPage />
    </DataboxProviders>
  );
}
